import firebase from "firebase/app";
import { firestore } from "../firebase";
import DB_PATH from "../DB_PATH";
import { AdCampaignPlan, parseCampaignPlan, validateCampaignPlan } from "../../types/AdCampaignPlan";

const planRef = (communityId: string) => {
  if (!communityId) throw new Error("Select a community before saving a campaign plan.");
  return firestore.collection(DB_PATH.COMMUNITY).doc(communityId)
    .collection("CampaignPlans").doc("current");
};

export const subscribeCampaignPlan = (
  communityId: string,
  onChange: (plan: AdCampaignPlan | null) => void,
  onError: (error: Error) => void
) => {
  let current: AdCampaignPlan | null = null;
  let legacy: AdCampaignPlan | null = null;
  let currentLoaded = false;
  let legacyLoaded = false;
  const emit = () => { if (currentLoaded && legacyLoaded) onChange(current || legacy); };
  const offCurrent = planRef(communityId).onSnapshot(snap => {
    current = parseCampaignPlan(snap.data()); currentLoaded = true; emit();
  }, onError);
  const legacyRef = firestore.collection(DB_PATH.COMMUNITY).doc(communityId).collection("AdEngine").doc("config");
  const offLegacy = legacyRef.onSnapshot(snap => {
    legacy = parseCampaignPlan(snap.data()?.campaignPlan); legacyLoaded = true; emit();
  }, onError);
  return () => { offCurrent(); offLegacy(); };
};

export const saveCampaignPlan = async (
  communityId: string, plan: AdCampaignPlan, expectedUpdatedAt: string
): Promise<void> => {
  validateCampaignPlan(plan);
  const ref = planRef(communityId);
  await firestore.runTransaction(async transaction => {
    const legacyRef = firestore.collection(DB_PATH.COMMUNITY).doc(communityId).collection("AdEngine").doc("config");
    const [snap, legacySnap] = await Promise.all([transaction.get(ref), transaction.get(legacyRef)]);
    const current = parseCampaignPlan(snap.exists ? snap.data() : legacySnap.data()?.campaignPlan);
    if ((current?.updatedAt || "") !== expectedUpdatedAt) {
      throw new Error("This plan changed while you were editing. Close and reopen it to load the latest version.");
    }
    transaction.set(ref, { ...plan, title: plan.title.trim(), updatedAt: new Date().toISOString() });
    if (legacySnap.data()?.campaignPlan) {
      transaction.update(legacyRef, { campaignPlan: firebase.firestore.FieldValue.delete() });
    }
  });
};
